import { supabase } from "@/integrations/supabase/client";
import { useQuery } from "@tanstack/react-query";

export interface SupplierTag {
	id: string;
	name: string;
}

export const useSupplierTags = () => {
	return useQuery({
		queryKey: ["supplier-tags"],
		queryFn: async (): Promise<SupplierTag[]> => {
			const { data, error } = await supabase
				.from("supplier_tags")
				.select("*")
				.order("name");

			if (error) throw error;
			return data || [];
		},
	});
};

export const getSupplierTags = async (
	supplierId: string
): Promise<SupplierTag[]> => {
	const { data, error } = await supabase
		.from("supplier_tag_relations")
		.select("tag_id, supplier_tags(id, name)")
		.eq("supplier_id", supplierId);

	if (error) throw error;

	console.log(data);

	return data.map((item: any) => ({
		id: item.supplier_tags.id,
		name: item.supplier_tags.name,
	}));
};

export const saveSupplierTags = async (
	supplierId: string,
	tagIds: string[]
) => {
	// First, remove all existing tags for this supplier
	const { error: deleteError } = await supabase
		.from("supplier_tag_relations")
		.delete()
		.eq("supplier_id", supplierId);

	if (deleteError) throw deleteError;

	// Skip if no tags to add
	if (!tagIds.length) return;

	// Then add the new tags
	const supplierTags = tagIds.map((tagId) => ({
		supplier_id: supplierId,
		tag_id: tagId,
	}));

	const { error: insertError } = await supabase
		.from("supplier_tag_relations")
		.insert(supplierTags);

	if (insertError) throw insertError;
};
